// The QR code printed on a pod encodes   https://app.bodycodez.com/scan-at/<code>
// where <code> is the device's opaque public code (connected_devices.qr_code). It is NOT the
// serial number and it is not a credential: it only tells a signed-in member which pod this is.

export const DEVICE_CODE_RE = /^[0-9a-f]{16}$/i;

export const SCAN_AT_ORIGIN = "https://app.bodycodez.com";

/** The device code inside a scanned QR payload (full URL or bare code), or null. */
export function extractDeviceCode(raw: string): string | null {
  const text = raw.trim();
  if (DEVICE_CODE_RE.test(text)) return text.toLowerCase();
  const match = /\/scan-at\/([0-9a-f]{16})(?:[/?#]|$)/i.exec(text);
  return match ? match[1].toLowerCase() : null;
}

/** What to encode in the QR sticker for a device. */
export function scanAtUrl(code: string, origin: string = SCAN_AT_ORIGIN): string {
  return `${origin}/scan-at/${code.toLowerCase()}`;
}

/** True where the browser can read a QR code with the camera itself (not iPhone Safari). */
export function canScanQrInApp(): boolean {
  return typeof window !== "undefined" && "BarcodeDetector" in window && !!navigator.mediaDevices?.getUserMedia;
}
